/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';

// Loadable Banner Types
import loadable from '@loadable/component';
import ComponentErrorBoundary from '../../../../EnterpriseID/Common/ComponentErrorBoundary/ComponentErrorBoundary';
import BlockHeading from '../../../../../ContentTypeComponents/BlockHeading';

const SubCollection = loadable(() => import(/* webpackChunkName: "SubCollection" */ '../../../../../ContentTypeComponents/SubCollection/SubCollection'));

const SubCollections = ({
    data,
}) => {
    const getCollection = () =>  {
        const contentTypeUid =  data?.merchandising?.reference?.[0]?.['_content_type_uid'];
        switch (contentTypeUid) {
            case 'subcollection_v2':
                return (
                    <ComponentErrorBoundary module="Merchandising.SubCollection">
                        {data?.merchandising?.heading && <BlockHeading heading={data.merchandising.heading} />}
                        <SubCollection data={data.merchandising} />
                    </ComponentErrorBoundary>
                );
            case 'simple_subcollection':
                return (
                    <ComponentErrorBoundary module="Merchandising.SubCollection">
                        {data?.merchandising?.heading && <BlockHeading heading={data.merchandising.heading} />}
                        <SubCollection data={data.merchandising} />
                    </ComponentErrorBoundary>
                );
            default: return null;
        }
    };

    return (
        <div data-testid="subCollection">
            {getCollection()}
        </div>
    );
};

SubCollections.propTypes = {
    data: object.isRequired,
};

export default SubCollections;
